// @flow

import { Badge, Divider, Tooltip } from "antd";
import { BotView, DateView, TopView, Wrapper } from "./MiniCard.styles";
import { Image } from "../common";
import { Link } from "react-router-dom";
import { SkeletonTicket } from "../../../components/Loaders/SkeletonTicket";
import { Title } from "../LoginPassword/LoginPassword.styles";
import { formatDatetime } from "../../../../lib/date";
import { getReservationCode } from "../../../../lib/helpers/reservation";
import { getTicketCode } from "../../../../lib/helpers/ticket";
import { useOffice } from "../../../../state/offices/hooks";
import Info from "./Info";
import React, { useEffect, useState } from "react";
import logos from "views/resources/logos/SVG";
import moment from "moment";
import type { Office, Ticket } from "types";
import { useLocation } from "react-router-dom";
import { pathOr } from "ramda";

interface Props {
	office: ?Office;
	ticket: Ticket;
	notification: Boolean;
}

const MiniTicketCard = ({
	office,
	line,
	ticket,
	notification,
	isReservation,
	reservationId,
	clickable,
	inTicketScreen,
	reservationDate,
}: Props) => {
	const location = useLocation();
	const title = `Número de ${
		(isReservation && "Reserva") || (!!ticket && "Ticket")
	}:`;

	const code =
		(isReservation && reservationId) ||
		(!!ticket && getTicketCode(ticket)) ||
		"N/A";

	const isInTicketHistoryScreen = location.pathname.match(/history/);

	const ticketDate =
		!!office && isReservation ? reservationDate : formatDatetime(ticket.inserted_at, office.timezone);

	const status = ticket && ticket.called ? "success" : "processing";

	if (!office || !ticket || !line) return <SkeletonTicket></SkeletonTicket>;

	const logo = pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = pathOr(false, ["options", "brand", "show_logo"], office);

	return (
		<Wrapper inTicketScreen={inTicketScreen} notification={notification}>
			<TopView>
				<Image>
					<img
						src={
							showLogo
								? logo
								: logos[`logo_${office.category_id}_color`]
						}
					/>
				</Image>
				<h4 className="officeName">{office.name}</h4>
				{ticket && !isInTicketHistoryScreen && (
					<Status status={status} />
				)}
			</TopView>
			<BotView>
				<Info title={title} body={code} position="left" />
				<Info
					title="Nombre de fila:"
					body={
						(typeof line === "string" ? line : line.name) ||
						(!!ticket && line) ||
						"Sin información"
					}
					position="right"
				/>
			</BotView>
			<DateView>
				<h4 className="title">Fecha de emisión: </h4>
				<h4 className="body">{ticketDate}</h4>
			</DateView>
		</Wrapper>
	);
};

const statusDict = {
	processing: "En espera de atención...",
	success: "Ticket atendido",
};

const Status = ({ status }) => {
	return (
		<Tooltip title={statusDict[status]}>
			<Badge status={status} />
		</Tooltip>
	);
};

export default MiniTicketCard;
